<div class="flex gap-2 justify-end">
  @if (!params.isEditing()) {
    <a
      panButton
      target="_blank"
      [routerLink]="['/home', 'manage', 'branch', params.branchId(), 'location', params.data.id]"
      [queryParams]="{ subpage: 'change-history' }"
      icon="history"
    >
      History
    </a>
  }
</div>
